// Path: src\Components\Home\HomePgae.jsx
import React, { useEffect, useState } from "react";
import BaseHome from "./BaseHome";
import AllGames from "../../assets/images/all-games.png";

import Games from "../../assets/images/games.svg";


import { useTranslation } from "react-i18next";
import FeaturedTournament from "./FeaturedTournament";
import Banner from "./Banner";
import RenewBox from "./RenewBox";
import SpinTheWheelPopup from "../Popup/SpinTheWheel";
import { freeGameList, allGameList } from "../../api/game.api";
import { url } from "../../config/url";
// import { convertNumberToMillions, kFormatter } from "../../Utilities/kFormatter";
import { useNavigate } from "react-router";
import CoinsClaimedPopup from "../Popup/CoinsClaimedPopup";
import { claimRewards, dailyRewardsList } from "../../api/rewards.api";
import { toastError } from "../../Utilities/toast";
import { getUserSubscriptionDetails } from "../../api/subscription.api";
import ListLoader from "../Common/ListLoader";

import { useSearchParams } from "react-router-dom";
import JoinViaInviteCodePopup from "./JoinViaInviteCode";

var CryptoJS = require("crypto-js");

export const initialFilter = {
  pagination: {
    pageNo: 1,
    recordPerPage: 100,
    sortBy: "order",
    sortDirection: "desc"
  }
};
// const kFormatter = (num) => {
//   return Math.abs(num) > 999 
//     ? Math.sign(num) * Math.floor(Math.abs(num) / 1000) + 'k'
//     : Math.sign(num) * Math.abs(num);
// };
const kFormatter = (num) => {
  if (Math.abs(num) > 999999) {
    // Format for millions
    return Math.sign(num) * (Math.abs(num) / 1000000).toFixed(1) + 'M';
  } else if (Math.abs(num) > 999) {
    // Format for thousands
    return Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k';
  } else {
    // Return the original number
    return Math.sign(num) * Math.abs(num);
  }
};


const HomePgae = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState(initialFilter);
  const [list, setList] = useState({});
  const [listPlayedCount, setListPlayedCount] = useState(0);
  const [allGame, setAllGame] = useState([]);
  const [dailyRewards, setDailyRewards] = useState([]);
  const [wonReward, setWonReward] = useState(null);
  const [isSpinTheWheelPopup, setisSpinTheWheelPopup] = useState(false);
  const [isCoinsClaimedPopup, setisCoinsClaimedPopup] = useState(false);
  const [isCodeExists, setIsCodeExists] = useState(false);
  const [inviteCode, setInviteCode] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams()
  const [userSubscriptionDetails, setUserSubscriptionDetails] = useState(null);

  useEffect(() => {
    fetchFreeGames();
    fetchAllGames();
    fetchUserSubscriptionDetails();
  }, [])

  const fetchUserSubscriptionDetails = async () => {
    try {
      let userDetails = JSON.parse(localStorage.getItem('profileLite'))
      const res = await getUserSubscriptionDetails(userDetails.user_id);
      if (res?.success && res?.data){
        setUserSubscriptionDetails(res?.data)
        localStorage.setItem("premiumUser", res?.data?.subscription?.isPremium)
        localStorage.setItem('noOfContest',res?.data?.nonPremiumUser?.noOfFreeContest)
        localStorage.setItem('noOfTournament',res?.data?.nonPremiumUser?.noOfFreeTournament)
        localStorage.setItem('noOfPrivateContest',res?.data?.nonPremiumUser?.noOfFreePrivateContest)
      }
      else {
        localStorage.setItem("premiumUser", false)
        setUserSubscriptionDetails(null)
      }
    } catch (error) {
      localStorage.setItem("premiumUser", false)
      setUserSubscriptionDetails(null)
    }
  };
  const fetchFreeGames = async () => {
    try {
      const res = await freeGameList();
      if (res?.success && res?.data) {
        setList(res?.data)
        setListPlayedCount(res?.totalJoinedPlayers || 0)
      }
      else {
        setList({})
        setListPlayedCount(0)
      }
    } catch (error) {
    }
  };

  const fetchAllGames = async () => {
    setLoading(true)
    try {
      const res = await allGameList(filter);
      if (res?.success && res?.data) {
        setAllGame(res?.data)
      }
      else {
        setAllGame([]);
      }
    } catch (error) {
    }
    setLoading(false)
    await fetchLoginRewards()
  };
  const fetchLoginRewards = async () => {
    try {
      const res = await dailyRewardsList({ pagination: { pageNo: 1, recordPerPage: 10, sortBy: "order", } });
      if (res?.success && res?.data && res?.data?.length>0 && res?.claimReward === false) {
        setDailyRewards(res?.data)
        setisSpinTheWheelPopup(true)
      }
      else {
        setDailyRewards([]);
      }
    } catch (error) {
    }
  };
  const onRewardWin = (reward) => {
    claimDailyLoginReward(reward);
  }
  const claimDailyLoginReward = async (reward) => {
    try {
      var _id = CryptoJS.AES.encrypt(reward?._id, url.ENCRYPT_KEY || "ATBBxfJWFjS7nCPL8jGNYPlO").toString()
      const res = await claimRewards({ reward: _id });
      setisSpinTheWheelPopup(false)
      if (res?.success) {
        setWonReward(reward);
        setisCoinsClaimedPopup(true)
      }else{
        toastError(res?.data?.errors[0]?.msg)
      }
    } catch (error) {
    }
  };
  const clickHandler = (name, id) => {
    localStorage.setItem("activeGame", name);
    localStorage.setItem("activeGameId", id);
    navigate("/game-type" + "/" + id);
  };
  const clickHandlerfreegames = (name, id) => {
    // localStorage.setItem("activeGame", name);
    // localStorage.setItem("activeGameId", id);
    navigate("/htmlFreeGames");
  };
  const [loading,setLoading] = useState(true);

  const ExitToApp = () => {
    // localStorage.clear();
    let value = JSON.stringify({ "tag": "back pressed" });
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(value);
    }
  }

  useEffect(() => {
    setIsCodeExists(false);
    setInviteCode("");
    let tempCode = searchParams.get('code') || localStorage.getItem('code') || null
    if (tempCode) {
      setIsCodeExists(true);
      setInviteCode(tempCode);
      removeParamsFromUrl(["code"]);
    }
  })

  function removeParamsFromUrl(paramsToRemove) {
    let url = new URL(window.location.href);
    let params = url.searchParams;
    paramsToRemove.forEach((param) => params.delete(param));
    let updatedQueryString = params.toString();
    let newUrl = url.origin + url.pathname + (updatedQueryString ? "?" + updatedQueryString : "");
    window.history.replaceState(null, "", newUrl);
  }

  return (
    <BaseHome isWallet={true} isFooter={true} title={t('esports')} onBackClick={() => ExitToApp()}>
      <Banner setLoading={setLoading}/>
      {userSubscriptionDetails && userSubscriptionDetails?.isRenewRequired && userSubscriptionDetails?.subscription?.isPremium && 
        <div className="mb-3"><RenewBox userSubscriptionDetails={userSubscriptionDetails} onClickRenewSubscription={() => {
          window.location.href = "/more/subscription-pack#subscription-duration-buttons-tabs"
        }} /></div>
      }
      <FeaturedTournament setLoading={setLoading}/>
      <section className="all-games">
        <div className="home-header home-header-v2">
          <img className="icon-30 me-2" src={AllGames} alt="allgames" />
          <span className='home-header-v2'>{t("allGames")}</span>
        </div>
        <div className="d-flex flex-wrap all-games-section" >
          {list && list?.title &&
            <div className="game-box" onClick={() => clickHandlerfreegames()}>
              <div className="px-1 pb-1 text-center">
                <p className="mb-0 mt-1 text-center">{list?.title}</p>
              </div>
              <div className="home-game">
                <div className="overlay"></div>

                <img className="" src={url?.IMAGE_URL + list?.featuredImage?.default} alt="game" />
                <span>
                  <img className="icon-16 me-2" src={Games} alt="game" />
                  {kFormatter(listPlayedCount)} {t('free_games.played')}
                </span>
              </div>
            </div>
          }
          {allGame?.length > 0 &&
            allGame.map((data, indp) => (
              <div className="game-box" onClick={() => clickHandler(data?.name, data?._id)}>
                <div className="px-1 pb-1 text-center ">
                <p className="mb-0 mt-1 text-center" >
                {data?.name?.length > 12 ? (
                          <marquee  >{data?.name}</marquee>
                        ) : (
                          data?.name
                        )}
                  </p>
                  {/* <p className="mb-0 mt-1 text-center" >{data?.name}</p> */}
                </div>
                <div className="home-game">
                  <div className="overlay"></div>

                  <img className="" src={url?.IMAGE_URL + data?.featuredImage?.default} alt="game" />
                  <span>
                    <img className="icon-16 me-2" src={Games} alt="game" />
                    {kFormatter(data?.playedCount || 0)} {t('free_games.played')}
                  </span>
                </div>
              </div>
            ))}
        </div>
      </section>
      {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}

      {isSpinTheWheelPopup && (
        <SpinTheWheelPopup
          isOpen={isSpinTheWheelPopup}
          title="spin the wheel"
          data={dailyRewards}
          onClose={() => setisSpinTheWheelPopup(false)}
          onRewardWin={onRewardWin}
        />
      )}
      {isCoinsClaimedPopup && (
        <CoinsClaimedPopup
          isOpen={isCoinsClaimedPopup}
          title="500"
          reward={wonReward}
          onClose={() => {
            setisCoinsClaimedPopup(false)
            window.location.href = window.location.pathname;
          }}
        />
      )}
      {isCodeExists &&
        <JoinViaInviteCodePopup inviteCode={inviteCode} />
      }
    </BaseHome>

  );
};

export default HomePgae;
